import { Ajv, Vms } from '@wayfinder/json-schemas';
import { keys, values, pick } from 'ramda';

/*
 * Return tools for JSON SCHEMA
 *
 * validate:    validate that an object conforms to the schemas[typeName]
 * from:        create an object pulling values from a sourceObject, and validate the result
 */
const tools = typeName => {
    // eslint-disable-next-line import-x/namespace
    const schema = Vms[`${typeName}`];
    const keysFromSchema = keys(schema.properties);

    /*
     * use Ajv to create a validation function for schema[typeName]
     * The resulting function signature will be :: POJO -> undefined|[String]
     *
     * NOTE: it's much cheaper to compile ajvValidate once, rather than every time we try to validate an object,
     * which is the only reason "tools" uses a closure
     */

    const ajvValidate = Ajv.createValidator(schema, ...values(Vms));

    /*
     * Check that o is valid based on schemas[typeName] and throw otherwise
     * @sig validate :: {k:v} -> {k:v}|Error
     */
    const validate = o => {
        const errors = ajvValidate(o);
        if (errors) throw new Error(errors.join('\n'));
        return o;
    };

    /*
     * Construct an object from a sourceObject, pulling only the fields required for this type from the
     * sourceObject and validate that the new object matches the JSON Schema for this type
     * @sig from :: {k:v} -> {k:v}|Error
     */
    const from = sourceObject => validate(pick(keysFromSchema, sourceObject));

    return {
        validate,
        from,
    };
};

export default tools;
